// extracted by mini-css-extract-plugin
export default {"Loading":"loading_Loading__bNbQI","Loading__img":"loading_Loading__img__Jn4Ru","loading__text":"loading_loading__text__eZsTv"};